import 'mapbox-gl/dist/mapbox-gl.css';
import './custom-styles.css';

import { registerPlugin } from 'components/plugins-entrypoint';
import { builder } from './geolocation-plugin';

registerPlugin(builder);
